// With auto-send on, Close loop only holds follow-ups the agent could not send,
// so it shows while there are some, or while it is the open tab.
export function closeLoopInMainQueue(
	closeLoopAutoSend: boolean,
	closeLoopCount: number | undefined,
	isActive: boolean,
): boolean {
	return !closeLoopAutoSend || isActive || (closeLoopCount ?? 0) > 0
}
